/**
 * Alluvion Home — Print Your Own Configurator
 * =============================================
 * Only runs on: /products/print-your-own-photo
 *
 * INSTALLATION — 3 steps
 * ─────────────────────────────────────────
 * STEP 1 — Add this file as a theme asset
 *   Shopify Admin → Online Store → Themes → Edit code
 *   Assets → Add a new asset → name it alluvion-configurator.js → paste this file
 *
 * STEP 2 — Load the script in layout/theme.liquid
 *   Find the closing </body> tag and paste ABOVE it:
 *
 *   {% if request.path contains '/products/print-your-own-photo' %}
 *     <script src="{{ 'alluvion-preview.js' | asset_url }}" defer></script>
 *     <script src="{{ 'alluvion-configurator.js' | asset_url }}" defer></script>
 *   {% endif %}
 *
 * STEP 3 — Add mount points in sections/main-product.liquid
 *   Find the price block and paste directly after it:
 *
 *   {% if product.handle == 'print-your-own-photo' %}
 *     <div id="alv-upload-section">
 *       <p class="alv-label">Your photo</p>
 *       <div class="alv-upload-zone" id="alv-upload-zone">
 *         <input type="file" id="alv-file-input" accept="image/*">
 *         <div class="alv-upload-idle" id="alv-upload-idle">
 *           <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
 *           <span>Click or drag to upload your photo</span>
 *           <span class="alv-upload-sub">JPG, PNG or TIFF &middot; min 1500px on shortest side</span>
 *         </div>
 *         <div class="alv-upload-overlay" id="alv-upload-overlay" style="display:none;">
 *           <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
 *           <span>Replace photo</span>
 *         </div>
 *         <button class="alv-remove-btn" id="alv-remove-btn" type="button" style="display:none;">&#x2715; Remove</button>
 *       </div>
 *       <p class="alv-res-warning" id="alv-res-warning" style="display:none;">
 *         &#9888; Your image may be too low resolution for this size and could print with reduced quality.
 *       </p>
 *     </div>
 *     <div id="alv-configurator"></div>
 *   {% endif %}
 *
 *   Also add this near the closing </div> of the product info section:
 *
 *   <script type="application/json" id="alv-product-json">
 *     {{ product | json }}
 *   </script>
 *
 * ─────────────────────────────────────────
 * SHOPIFY ADMIN — PRODUCT SETUP
 * ─────────────────────────────────────────
 * Option 1 — Size:          A5, A4, A3, A2, A1
 * Option 2 — Style:         Print Only, Black Frame, White Frame, Dark Oak Frame, Light Oak Frame
 * Option 3 — Passepartout:  No Passepartout, A5 Window (A4 Frame), A4 Window (A3 Frame),
 *                           A3 Window (A2 Frame), A2 Window (A1 Frame), A1 Window (A0 Frame)
 *
 * Only create VALID variant combinations. Valid passepartout per size:
 *   A5 → No Passepartout OR A5 Window (A4 Frame)
 *   A4 → No Passepartout OR A4 Window (A3 Frame)
 *   A3 → No Passepartout OR A3 Window (A2 Frame)
 *   A2 → No Passepartout OR A2 Window (A1 Frame)
 *   A1 → No Passepartout OR A1 Window (A0 Frame)
 */

(function () {
  'use strict';

  /* ── Guard: only run on this product ─────────────────────────────── */
  if (!window.location.pathname.includes('/products/print-your-own-photo')) return;

  /* ── Cloudflare Worker URL ────────────────────────────────────────── */
  var WORKER_URL = 'https://alluvion-upload.elliot-389.workers.dev';

  /* ── Compatibility map ────────────────────────────────────────────── */
  var PASSE_MAP = {
    'A5': 'A5 Window (A4 Frame)',
    'A4': 'A4 Window (A3 Frame)',
    'A3': 'A3 Window (A2 Frame)',
    'A2': 'A2 Window (A1 Frame)',
    'A1': 'A1 Window (A0 Frame)'
  };

  /* Minimum pixels on shortest side per print size */
  var MIN_PX = { A5: 874, A4: 1240, A3: 1748, A2: 2480, A1: 3508 };

  /* ── State ────────────────────────────────────────────────────────── */
  var productData = null;
  var sel = { Size: null, Style: null, Passepartout: null };
  var imgW = 0, imgH = 0;
  var photoReady = false;
  var photoFile = null;
  var photoUrl = null;
  var isUploading = false;

  /* ── Boot ─────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {

    var jsonEl = document.getElementById('alv-product-json');
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) {
        console.warn('[Alluvion] Could not parse product JSON.', e);
      }
    }

    if (!productData) {
      console.warn('[Alluvion] Product JSON not found — configurator not loaded.');
      return;
    }

    injectStyles();
    buildConfigurator();
    bindUploadEvents();
    interceptAddToCart();

    /* Pre-select variant from URL param if present */
    var urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    if (urlVariantId) preSelectVariant(urlVariantId);
  });

  /* ── Dispatch event to preview script ───────────────────────────── */
  function dispatchPreviewEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  /* ── Pre-select a variant from URL param ─────────────────────────── */
  function preSelectVariant(variantId) {
    var variant = productData.variants.find(function (v) { return v.id === variantId; });
    if (!variant) return;
    productData.options.forEach(function (name, idx) {
      sel[name] = variant['option' + (idx + 1)];
    });
    renderButtons();
    syncWithShopify();
    notifyPreview();
  }

  /* ── Build the configurator HTML ─────────────────────────────────── */
  function buildConfigurator() {
    var root = document.getElementById('alv-configurator');
    if (!root) return;

    productData.options.forEach(function (optionName) {
      var values = getOptionValues(optionName);
      var section = document.createElement('div');
      section.className = 'alv-section';

      var label = document.createElement('p');
      label.className = 'alv-label';
      label.textContent = optionName;
      section.appendChild(label);

      var grid = document.createElement('div');
      grid.className = 'alv-grid';
      grid.id = 'alv-grid-' + optionName.toLowerCase();
      section.appendChild(grid);

      values.forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'alv-btn';
        btn.textContent = value;
        btn.dataset.option = optionName;
        btn.dataset.value = value;
        btn.addEventListener('click', function () { onSelect(optionName, value); });
        grid.appendChild(btn);
      });

      root.appendChild(section);
    });

    var note = document.createElement('p');
    note.id = 'alv-frame-note';
    note.className = 'alv-frame-note';
    root.appendChild(note);
  }

  /* ── Get unique ordered values for an option ─────────────────────── */
  function getOptionValues(optionName) {
    var idx = productData.options.indexOf(optionName);
    if (idx === -1) return [];
    var key = 'option' + (idx + 1);
    var seen = [];
    productData.variants.forEach(function (v) {
      if (seen.indexOf(v[key]) === -1) seen.push(v[key]);
    });
    return seen;
  }

  /* ── Handle a button click ───────────────────────────────────────── */
  function onSelect(optionName, value) {
    sel[optionName] = sel[optionName] === value ? null : value;

    if (optionName === 'Size') {
      var valid = getValidPasseValues(sel.Size);
      if (sel.Passepartout && valid.indexOf(sel.Passepartout) === -1) {
        sel.Passepartout = null;
      }
    }

    renderButtons();
    syncWithShopify();
    checkResolution();
    notifyPreview();
  }

  /* ── Notify preview of current selection ────────────────────────── */
  function notifyPreview() {
    dispatchPreviewEvent('alv:style-changed', { style: sel.Style });
    dispatchPreviewEvent('alv:passe-changed', {
      passe: sel.Passepartout && sel.Passepartout !== 'No Passepartout'
    });
  }

  /* ── Valid passepartout options for a given size ─────────────────── */
  function getValidPasseValues(size) {
    if (!size) return [];
    return ['No Passepartout', PASSE_MAP[size]].filter(Boolean);
  }

  /* ── Re-render button selected / disabled states ─────────────────── */
  function renderButtons() {
    var currentSize = sel['Size'];

    document.querySelectorAll('.alv-btn').forEach(function (btn) {
      var opt = btn.dataset.option;
      var value = btn.dataset.value;
      var isSelected = sel[opt] === value;
      var isDisabled = false;

      if (opt === 'Passepartout') {
        var valid = getValidPasseValues(currentSize);
        isDisabled = !!currentSize && valid.indexOf(value) === -1;
      }

      btn.classList.toggle('alv-btn--selected', isSelected);
      btn.classList.toggle('alv-btn--disabled', isDisabled);
      btn.disabled = isDisabled;
    });

    var note = document.getElementById('alv-frame-note');
    if (note) {
      if (sel.Size && sel.Style && sel.Passepartout && sel.Passepartout !== 'No Passepartout') {
        note.textContent = sel.Style === 'Print Only'
          ? 'Your ' + sel.Size + ' print will include a passepartout board — delivered unframed.'
          : 'Your ' + sel.Size + ' print will be mounted with a passepartout in a larger frame.';
      } else {
        note.textContent = '';
      }
    }
  }

  /* ── Find the matching Shopify variant ───────────────────────────── */
  function findVariant() {
    if (!sel.Size || !sel.Style || !sel.Passepartout) return null;
    return productData.variants.find(function (v) {
      return productData.options.every(function (name, idx) {
        return v['option' + (idx + 1)] === sel[name];
      });
    }) || null;
  }

  /* ── Sync by clicking Dawn's own hidden radio buttons ────────────── */
  function syncWithShopify() {
    if (!sel.Size || !sel.Style || !sel.Passepartout) return;

    productData.options.forEach(function (optionName) {
      var value = sel[optionName];
      if (!value) return;
      var allRadios = document.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < allRadios.length; i++) {
        var radio = allRadios[i];
        if (radio.value === value && radio.name.indexOf(optionName) !== -1) {
          radio.click();
          break;
        }
      }
    });

    setTimeout(function () {
      var variant = findVariant();
      if (variant) updatePrice(variant);
    }, 50);
  }

  /* ── Intercept Add to Cart ───────────────────────────────────────── */
  function interceptAddToCart() {
    var atcBtn = document.querySelector('.product-form__submit');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', function (e) {
      if (!photoFile || isUploading) return;
      if (photoUrl) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      isUploading = true;
      var originalText = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Uploading photo…';

      var variant = findVariant();
      if (!variant) {
        alert('Please select all options before adding to cart.');
        atcBtn.disabled = false;
        atcBtn.textContent = originalText;
        isUploading = false;
        return;
      }

      var formData = new FormData();
      formData.append('file', photoFile);

      fetch(WORKER_URL, { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.url) throw new Error(data.error || 'No URL returned');
        photoUrl = data.url;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1, properties: { 'Photo': photoUrl } }]
          })
        });
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        isUploading = false;
        atcBtn.disabled = false;
        atcBtn.textContent = originalText;
        photoUrl = null;
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[Alluvion] Error:', err);
        alert('Sorry, there was a problem. Please try again.');
        isUploading = false;
        atcBtn.disabled = false;
        atcBtn.textContent = originalText;
        photoUrl = null;
      });

    }, true);
  }

  /* ── Update Dawn's price display ─────────────────────────────────── */
  function updatePrice(variant) {
    var raw = variant.price;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var symbol = currency === 'GBP' ? '£' : currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency + ' ';
    var formatted = symbol + (raw / 100).toFixed(2);

    document.querySelectorAll('.price-item--regular').forEach(function (el) {
      el.textContent = formatted;
    });

    if (variant.compare_at_price && variant.compare_at_price > raw) {
      var compareFormatted = symbol + (variant.compare_at_price / 100).toFixed(2);
      document.querySelectorAll('.price-item--sale').forEach(function (el) { el.textContent = formatted; });
      document.querySelectorAll('.price-item--regular').forEach(function (el) { el.textContent = compareFormatted; });
      document.querySelectorAll('.price').forEach(function (el) { el.classList.add('price--on-sale'); });
    } else {
      document.querySelectorAll('.price').forEach(function (el) { el.classList.remove('price--on-sale'); });
    }
  }

  /* ── Photo upload handlers ───────────────────────────────────────── */
  function bindUploadEvents() {
    var fileInput = document.getElementById('alv-file-input');
    var zone      = document.getElementById('alv-upload-zone');
    var removeBtn = document.getElementById('alv-remove-btn');
    if (!fileInput || !zone) return;

    zone.addEventListener('click', function (e) {
      if (removeBtn && (e.target === removeBtn || removeBtn.contains(e.target))) return;
      fileInput.click();
    });

    fileInput.addEventListener('change', function (e) {
      if (e.target.files[0]) handleFile(e.target.files[0]);
    });

    zone.addEventListener('dragover', function (e) {
      e.preventDefault();
      zone.classList.add('alv-upload-zone--dragover');
    });
    zone.addEventListener('dragleave', function () {
      zone.classList.remove('alv-upload-zone--dragover');
    });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('alv-upload-zone--dragover');
      var file = e.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) handleFile(file);
    });

    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        clearPhoto();
      });
    }
  }

  function handleFile(file) {
    photoFile = file;
    photoUrl = null;
    var reader = new FileReader();
    reader.onload = function (ev) {
      var img = new Image();
      img.onload = function () {
        imgW = img.naturalWidth;
        imgH = img.naturalHeight;
        showPreview(ev.target.result);
        photoReady = true;
        checkResolution();

        /* Notify preview of new photo and orientation */
        var orientation = imgW >= imgH ? 'landscape' : 'portrait';
        dispatchPreviewEvent('alv:photo-changed', {
          dataUrl: ev.target.result,
          orientation: orientation
        });
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  }

  function showPreview(src) {
    var zone    = document.getElementById('alv-upload-zone');
    var idle    = document.getElementById('alv-upload-idle');
    var overlay = document.getElementById('alv-upload-overlay');
    var remove  = document.getElementById('alv-remove-btn');
    if (!zone) return;

    var preview = zone.querySelector('.alv-preview');
    if (!preview) {
      preview = document.createElement('img');
      preview.className = 'alv-preview';
      preview.alt = 'Your uploaded photo preview';
      zone.insertBefore(preview, zone.firstChild);
    }
    preview.src = src;
    zone.classList.add('alv-upload-zone--has-image');
    if (idle)    idle.style.display    = 'none';
    if (overlay) overlay.style.display = 'flex';
    if (remove)  remove.style.display  = 'inline-block';
  }

  function clearPhoto() {
    var zone    = document.getElementById('alv-upload-zone');
    var idle    = document.getElementById('alv-upload-idle');
    var overlay = document.getElementById('alv-upload-overlay');
    var remove  = document.getElementById('alv-remove-btn');
    var input   = document.getElementById('alv-file-input');
    if (!zone) return;

    var preview = zone.querySelector('.alv-preview');
    if (preview) preview.remove();
    zone.classList.remove('alv-upload-zone--has-image');
    if (idle)    idle.style.display    = 'flex';
    if (overlay) overlay.style.display = 'none';
    if (remove)  remove.style.display  = 'none';
    if (input)   input.value           = '';
    photoReady  = false;
    photoFile   = null;
    photoUrl    = null;
    imgW = imgH = 0;
    checkResolution();
    dispatchPreviewEvent('alv:photo-cleared');
  }

  function checkResolution() {
    var warn = document.getElementById('alv-res-warning');
    if (!warn) return;
    if (!photoReady || !sel.Size) { warn.style.display = 'none'; return; }
    warn.style.display = Math.min(imgW, imgH) < MIN_PX[sel.Size] ? 'block' : 'none';
  }

  /* ── Inject scoped CSS ────────────────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('alv-styles')) return;
    var style = document.createElement('style');
    style.id = 'alv-styles';
    style.textContent = [
      '#alv-upload-section { margin-bottom: 2.4rem; }',
      '.alv-label { font-size: 1.3rem; font-weight: 600; letter-spacing: .06em; text-transform: uppercase; margin: 0 0 .8rem; color: rgb(var(--color-foreground)); }',
      '.alv-upload-zone { position: relative; overflow: hidden; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 180px; border: 1px dashed rgba(var(--color-foreground),.3); border-radius: var(--buttons-radius,4px); background: rgba(var(--color-foreground),.03); cursor: pointer; transition: background .15s, border-color .15s; }',
      '.alv-upload-zone:hover, .alv-upload-zone--dragover { background: rgba(var(--color-foreground),.07); border-color: rgba(var(--color-foreground),.55); }',
      '#alv-file-input { display: none; }',
      '.alv-upload-idle { display: flex; flex-direction: column; align-items: center; gap: .5rem; color: rgba(var(--color-foreground),.55); font-size: 1.3rem; pointer-events: none; text-align: center; padding: 0 1rem; }',
      '.alv-upload-sub { font-size: 1.1rem; color: rgba(var(--color-foreground),.38); }',
      '.alv-preview { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }',
      '.alv-upload-overlay { position: absolute; inset: 0; background: rgba(0,0,0,.45); flex-direction: column; align-items: center; justify-content: center; gap: .5rem; color: #fff; font-size: 1.3rem; cursor: pointer; }',
      '.alv-upload-zone--has-image:hover .alv-upload-overlay { display: flex !important; }',
      '.alv-remove-btn { position: absolute; top: 8px; right: 8px; z-index: 2; background: rgb(var(--color-background)); border: 1px solid rgba(var(--color-foreground),.2); border-radius: var(--buttons-radius,4px); padding: 4px 10px; font-size: 1.1rem; font-family: inherit; cursor: pointer; color: rgb(var(--color-foreground)); }',
      '.alv-res-warning { margin-top: .6rem; font-size: 1.2rem; color: #b45309; }',
      '#alv-configurator { margin-bottom: 1.6rem; }',
      '.alv-section { margin-bottom: 1.8rem; }',
      '.alv-grid { display: flex; flex-wrap: wrap; gap: .8rem; }',
      '.alv-btn { padding: .65rem 1.4rem; font-size: 1.3rem; font-family: inherit; border: 1px solid rgba(var(--color-foreground),.3); border-radius: var(--buttons-radius,4px); background: transparent; color: rgb(var(--color-foreground)); cursor: pointer; white-space: nowrap; transition: background .12s, border-color .12s, color .12s; }',
      '.alv-btn:hover:not(:disabled) { background: rgba(var(--color-foreground),.06); border-color: rgba(var(--color-foreground),.6); }',
      '.alv-btn--selected { background: rgb(var(--color-foreground)); color: rgb(var(--color-background)); border-color: rgb(var(--color-foreground)); }',
      '.alv-btn--disabled { opacity: .28; cursor: not-allowed; }',
      '.alv-frame-note { margin-top: .7rem; font-size: 1.2rem; color: rgba(var(--color-foreground),.5); min-height: 1.6rem; margin-bottom: 0; }',
      'fieldset.js.product-form__input { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

})();